// VIETTEL
// const URL = "https://viettelgroup.ai/nlp/api/v1/spell-checking";
// const TOKEN =
//   "Iy-CAN826Xe8kITG8D4YfzA89vIk76pUs1IjTB7-0iY0rbwt8TT8p-ouIow6vQQ1";
// const spellCheck = async (text) => {
//   if (text) {
//     //let cleanText = text.replace(/(<([^>]+)>)/ig, ''); // remove all html tag
//     //cleanText = cleanText.replace(/\s\s+/g, ' '); // remove multiple space
//     //cleanText = cleanText.replace(/\&nbsp;/g, '')
//     let cleanText = text.toString();
//     cleanText = cleanText.replace(
//       /<[^>]*(>|$)|&nbsp;|&zwnj;|&raquo;|&laquo;|&gt;/g,
//       " "
//     );
//     const data = {
//       sentence: cleanText,
//     };

//     const requestOptions = {
//       method: "POST",
//       headers: {
//         "content-type": "application/json",
//       },
//       body: JSON.stringify(data),
//     };

//     try {
//       const response = await fetch(URL, requestOptions);
//       return response.json();
//     } catch (err) {
//       console.log(err);
//     }
//     return {};
//   }

//   return {};
// };

// VSPELL
const URL = 'https://spellcheck.saostar.vn/';
const spellCheck = async (text) => {
  if (text) {
    try{
      const data = new URLSearchParams();
      data.append('htmlString', text);

      const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          // 'Access-Control-Allow-Headers': '*'
        },
        body: data
      };

      const response = await fetch(URL, requestOptions);

      return response.json();
    }
    catch(error){
      console.log(error);
      return null;
    }
  }

  return null;

  // EXAMPLE RESPONSE
  // {
  //   "Version": null,
  //   "HtmlDocument": "tả+<span id='VSpellError_0' style='background-color:yellow' class='suggestion'>xxúng</span>+hữu+đột",
  //   "Suggestions": [
  //     "xúng|súng|sún|xung|xùng|xụng|xứng|xưng|xừng|xửng|xững"
  //   ],
  //   "SuggestionCount": 1,
  //   "Summary": null
  // }
}

export default spellCheck;
